import client from './main-client';

export const consultantCategoriesApi = (params) => client().get('/consultant-categories', { params });
